import { render, staticRenderFns } from "./DeviceReagentList.vue?vue&type=template&id=0b730222&scoped=true&"
import script from "./DeviceReagentList.vue?vue&type=script&lang=js&"
export * from "./DeviceReagentList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceReagentList.vue?vue&type=style&index=0&id=0b730222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b730222",
  null
  
)

export default component.exports